/**
 * Craft/Dawn系: メインの左右矢印で、サムネを前後に切り替えてメイン画像も切り替える
 */
document.addEventListener(
  "click",
  (e) => {
    const arrow = e.target.closest(
      "media-gallery .slider-buttons .slider-button"
    );
    if (!arrow) return;

    const gallery = arrow.closest("media-gallery");
    if (!gallery) return;

    // サムネのスライダー（下段）を取得
    const thumbSlider = gallery.querySelector(
      'slider-component.thumbnail-slider'
    );
    if (!thumbSlider) return;

    const thumbItems = Array.from(
      thumbSlider.querySelectorAll("li.thumbnail-list__item")
    );
    if (thumbItems.length <= 1) return;

    // 現在選択中（aria-current）のサムネを探す
    const currentIndex = thumbItems.findIndex((li) =>
      li.querySelector('button.thumbnail[aria-current="true"], button.thumbnail[aria-current]')
    );

    const safeCurrentIndex = currentIndex >= 0 ? currentIndex : 0;

    const dir = arrow.classList.contains("slider-button--next") ? 1 : -1;
    const nextIndex =
      (safeCurrentIndex + dir + thumbItems.length) % thumbItems.length;

    const nextThumbBtn = thumbItems[nextIndex].querySelector("button.thumbnail");
    if (!nextThumbBtn) return;

    // 余計な挙動を止めて、サムネクリックで切替
    e.preventDefault();
    e.stopPropagation();

    nextThumbBtn.click();
  },
  true
);
